export default __webpack_public_path__ + "static/media/light_leaderboard_icon.4d8a2571.svg";